<template>
  <div class="portfolioHeader-container">
      <span class="portfolioHeader-title">Análisis de portafolio de inversión</span>
      <img src="/static/logo.svg" class="portfolio-logo">
      <div class="border-element"></div>
      <div class="portfolioHeader-subtitles">
        <span class="portfolioHeader-contractNumber">{{ generalData.contractNumber }}</span> / <span class="portfolioHeader-cuttofDate">{{ generalData.creationDate}}</span>
        <span class="portfolioHeader-alias"><strong>Alias:</strong> {{ generalData.alias }} </span>
      </div>
      <el-row>
        <el-col :span="8">
          <div v-on:click="goToOverview" class="portfolioHeader-navigation">
            <span class="overview-title">Posición actual</span>
            <span class="overview-amount">{{ formatTotalAmount(generalData.totalInvestment) }}</span>
            <span class="overview-porcentage">100%</span>
          </div>
        </el-col>
        <el-col v-if="isAssetClassSection" :span="8" class="assetClass-navigation">
          <asset-class-menu :current-asset-class="currentAssetClass" :total-amount="assetClassAmount"
          :percentage="assetClassPercentage" :menu-data="menuData" :section-label="sectionLabel" :is-asset-detail="isAssetDetail"></asset-class-menu>
        </el-col>
        <el-col v-if="isAssetDetail" :span="7" :class="['asset-container-menu', currentAssetClass]">
          <span class="asset-title">{{assetDetail.assetName}}</span>
          <span class="asset-amount">{{ formatTotalAmount(assetDetail.amount) }}</span>
          <span class="asset-porcentage">{{formatPercentage(assetDetail.percentage)}}</span>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import AssetClassMenu from './AssetClassMenu';
export default {
  name: 'PortfolioHeader',
  props:
  {
    generalData: {},
    isAssetClassSection: false,
    sectionLabel: '',
    currentAssetClass: '',
    assetClassAmount: 0,
    assetClassPercentage: 0,
    isAssetDetail: false,
    menuData: {},
    assetDetail: {}
  },
  components: {
    'asset-class-menu': AssetClassMenu
  },
  methods: {
    goToOverview () {
      const portfolioId = this.$route.params.id
      this.$router.push(`/analisis-portafolio/${portfolioId}`)
    },
    formatPercentage (percentage) {
      percentage = percentage*100
      return `${percentage.toFixed(2)}%`
    },
    formatTotalAmount (amount) {
      amount = parseFloat(amount) || 0
      return `$${amount.toLocaleString()}`
    }
  }
}
</script>
<style scoped>
  .portfolioHeader-title {
    font-size: 20px;
    font-weight: bold;
    margin: 25px 0;
    display: flex;
  }

  .portfolioHeader-container {
    text-align: left;
    padding: 15px 0;
    line-height: 20px;
  }

  .portfolioHeader-subtitles {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: bold;
    color: #001F5C;
  }

  .portfolioHeader-alias {
    color: #848484;
    font-size: 15px;
    float: right;
  }

  .portfolioHeader-navigation {
    border: 1px solid#E9E9E9;
    padding: 10px;
    display: flex;
    flex-direction: column;
    border-radius: 2px;
    margin-right: 5px;
    cursor: pointer;
  }

  .overview-title {
    color: #2873DE;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .overview-title.asset-class {
    color: #4A4A4A;
  }

  .overview-amount {
    color: #4A4A4A;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .overview-porcentage {
    color: #4A4A4A;
    font-size: 14px;
  }

  .asset-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    color: #4A4A4A;
    font-weight: bold;
    font-size: 18px;
  }

  .asset-amount {
    color: #4A4A4A;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .asset-porcentage {
    font-size: 14px;
    color: #4A4A4A;
  }

  .asset-container-menu {
    color: #FFF;
    padding: 10px;
    display: flex;
    flex-direction: column;
    border-radius: 2px;
    height: 99px;
    z-index: 1;
    margin-left: 5px;
  }

  .asset-container-menu.deuda {
    background-color: #97E3D6;
  }

  .asset-container-menu.estructurados {
    background-color: #FB8070;
  }

  .asset-container-menu.capitales {
    background-color: #B3DE69;
  }

  .asset-container-menu.fondosrf {
    background-color: #C2BFE0;
  }

  .asset-container-menu.fondosrv {
    background-color: #FDB462;
  }

  .portfolio-logo {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/PortfolioHeader.vue